import PropTypes from 'prop-types';

import { SplashScreen } from 'src/components/loading-screen';

import { EntityContext } from './entity-context';

// ----------------------------------------------------------------------

export function EntityConsumer({ children }) {
  return (
    <EntityContext.Consumer>
      {(auth) => (auth.loading ? <SplashScreen /> : children)}
    </EntityContext.Consumer>
  );
}

EntityConsumer.propTypes = {
  children: PropTypes.node,
};
